import { api } from './api';
import type { BreadcrumbInput } from '@/types/pda-zone';
import { Capacitor } from '@capacitor/core';

/**
 * Whether the app is running on a native platform (iOS/Android).
 * Extracted here so the store doesn't depend on Capacitor directly.
 */
export const isNativePlatform = Capacitor.isNativePlatform();

export async function flushBreadcrumbs(
  zoneId: string,
  points: BreadcrumbInput[],
): Promise<void> {
  await api.post(`/pda-zones/zones/${zoneId}/breadcrumbs`, { points });
}
